module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inner-conntent"
  }, [_c('div', {
    staticClass: "logo"
  }, [(_vm.showMaintain) ? _c('div', {
    staticClass: "tips-box"
  }, [_c('div', {
    staticClass: "gt-tips"
  }, [_vm._v("\n            " + _vm._s(_vm.$t('message.maintain')) + "\n        ")])]) : _vm._e()]), _c('router-view')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-613bd087","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/login-register.vue
// module id = 655
// module chunks = 12